(function () {
  'use strict';

  var SEARCH_CLASS = 'oz-free-au-search-view';
  var COLLECTION_CLASS = 'oz-free-au-collection-view';
  var VIEW_NAME = 'free-au-shipping';
  var COLLECTION_PATH = '/collections/free-au-shipping';
  var BASE_QUERY = '(tag:"AU Free Shipping" OR tag:"AU Free Shipping Except Remote")';
  var CATEGORY_VALUES = [
    'Appliances',
    'Audio & Video',
    'Auto Accessories',
    'Baby & Kids',
    'Commercial',
    'Electronics',
    'Fashion',
    'Food & Beverage',
    'Furniture',
    'Gift & Novelty',
    'Hampers',
    'Health & Beauty',
    'Home & Garden',
    'Occasions',
    'Outdoor Recreation',
    'Pet Care',
    'Sports & Fitness',
    'Tools'
  ];
  var queued = false;

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function setPageClasses() {
    var path = window.location.pathname;
    var params = new URLSearchParams(window.location.search);
    var isSearch = path.indexOf('/search') === 0 && params.get('view') === VIEW_NAME;
    var isCollection = path.indexOf(COLLECTION_PATH) === 0;

    document.documentElement.classList.toggle('oz-free-au-page', isSearch || isCollection);
    document.documentElement.classList.toggle(SEARCH_CLASS, isSearch);
    document.documentElement.classList.toggle(COLLECTION_CLASS, isCollection);
  }

  function selectedCategory() {
    var query = new URLSearchParams(window.location.search).get('q') || '';

    for (var i = 0; i < CATEGORY_VALUES.length; i += 1) {
      var token = 'tag:"' + CATEGORY_VALUES[i].replace(/"/g, '\\"') + '"';
      if (query.indexOf(token) !== -1) return CATEGORY_VALUES[i];
    }

    return 'Free AU Shipping';
  }

  function updatePageTitle() {
    document.querySelectorAll('[data-oz-free-au-page-title-text]').forEach(function (heading) {
      heading.textContent = selectedCategory();
    });
  }

  function injectHiddenField(form, name, value) {
    if (!form || !value || form.querySelector('input[name="' + name + '"]')) return;

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function preserveSearchView() {
    if (!document.documentElement.classList.contains(SEARCH_CLASS)) return;

    var params = new URLSearchParams(window.location.search);
    var query = params.get('q') || '';

    document.querySelectorAll('facet-filters-form form').forEach(function (form) {
      injectHiddenField(form, 'view', VIEW_NAME);
      injectHiddenField(form, 'type', 'product');
      injectHiddenField(form, 'q', query);
      injectHiddenField(form, 'options[prefix]', 'last');
    });
  }

  function makeSearchUrl(query, filters) {
    var params = new URLSearchParams();
    params.set('view', VIEW_NAME);
    params.set('type', 'product');
    params.set('q', query);
    params.set('options[prefix]', 'last');

    Object.keys(filters || {}).forEach(function (key) {
      var value = filters[key];
      if (value !== undefined && value !== null && value !== '') params.set(key, value);
    });

    return '/search?' + params.toString();
  }

  function makeLink(label, url) {
    return '<li><a class="oz-free-au-custom-facets__link" href="' + escapeHtml(url) + '">' +
      '<span class="oz-free-au-custom-facets__check" aria-hidden="true"></span>' +
      '<span>' + escapeHtml(label) + '</span></a></li>';
  }

  function categoryLinks() {
    return CATEGORY_VALUES.map(function (category) {
      var query = BASE_QUERY + ' AND tag:"' + category.replace(/"/g, '\\"') + '"';
      return '<li data-oz-category-item data-oz-category-name="' + escapeHtml(category.toLowerCase()) + '">' +
        '<a class="oz-free-au-custom-facets__link" href="' + escapeHtml(makeSearchUrl(query)) + '">' +
        '<span class="oz-free-au-custom-facets__check" aria-hidden="true"></span>' +
        '<span>' + escapeHtml(category) + '</span></a></li>';
    }).join('');
  }

  function fallbackMarkup() {
    var availability = [
      makeLink('All products', COLLECTION_PATH),
      makeLink('In stock', makeSearchUrl(BASE_QUERY, { 'filter.v.availability': '1' }))
    ].join('');

    var prices = [
      makeLink('Under $50', makeSearchUrl(BASE_QUERY, { 'filter.v.price.lte': '50' })),
      makeLink('$50 to $100', makeSearchUrl(BASE_QUERY, { 'filter.v.price.gte': '50', 'filter.v.price.lte': '100' })),
      makeLink('$100 to $250', makeSearchUrl(BASE_QUERY, { 'filter.v.price.gte': '100', 'filter.v.price.lte': '250' })),
      makeLink('$250 to $500', makeSearchUrl(BASE_QUERY, { 'filter.v.price.gte': '250', 'filter.v.price.lte': '500' })),
      makeLink('$500 and over', makeSearchUrl(BASE_QUERY, { 'filter.v.price.gte': '500' }))
    ].join('');

    var shipping = [
      makeLink('All free-shipping products', makeSearchUrl(BASE_QUERY)),
      makeLink('Australia-wide free shipping', makeSearchUrl('tag:"AU Free Shipping"')),
      makeLink('Free shipping except remote areas', makeSearchUrl('tag:"AU Free Shipping Except Remote"'))
    ].join('');

    return '' +
      '<div class="oz-free-au-custom-facets" data-oz-free-au-custom-facets>' +
        '<details class="oz-free-au-custom-facets__drawer">' +
          '<summary class="oz-free-au-custom-facets__summary">' +
            '<span>Filter &amp; refine</span>' +
            '<span class="oz-free-au-custom-facets__summary-caret" aria-hidden="true"></span>' +
          '</summary>' +
          '<div class="oz-free-au-custom-facets__body">' +
            '<div class="oz-free-au-custom-facets__header">' +
              '<h2 class="oz-free-au-custom-facets__title" id="verticalTitle">Filter by</h2>' +
              '<a class="oz-free-au-custom-facets__clear" href="' + COLLECTION_PATH + '">Clear all</a>' +
            '</div>' +
            '<div class="oz-free-au-custom-facets__group">' +
              '<h3 class="oz-free-au-custom-facets__group-title">Availability</h3>' +
              '<ul class="oz-free-au-custom-facets__list">' + availability + '</ul>' +
            '</div>' +
            '<div class="oz-free-au-custom-facets__group">' +
              '<h3 class="oz-free-au-custom-facets__group-title">Price</h3>' +
              '<ul class="oz-free-au-custom-facets__list">' + prices + '</ul>' +
            '</div>' +
            '<div class="oz-free-au-custom-facets__group">' +
              '<h3 class="oz-free-au-custom-facets__group-title">Category</h3>' +
              '<label class="visually-hidden" for="OzFreeAuCategorySearch">Search categories</label>' +
              '<input class="oz-free-au-custom-facets__search" id="OzFreeAuCategorySearch" type="search" placeholder="Search categories" autocomplete="off" data-oz-category-search>' +
              '<ul class="oz-free-au-custom-facets__list oz-free-au-custom-facets__category-list" data-oz-category-list>' + categoryLinks() + '</ul>' +
              '<p class="oz-free-au-custom-facets__empty" data-oz-category-empty>No matching category</p>' +
            '</div>' +
            '<div class="oz-free-au-custom-facets__group">' +
              '<h3 class="oz-free-au-custom-facets__group-title">Shipping coverage</h3>' +
              '<ul class="oz-free-au-custom-facets__list">' + shipping + '</ul>' +
            '</div>' +
            '<p class="oz-free-au-custom-facets__note">Select an option to refine this collection. Additional brand and product filters appear with the filtered results.</p>' +
          '</div>' +
        '</details>' +
      '</div>';
  }

  function injectLargeCatalogFacets() {
    if (!document.documentElement.classList.contains(COLLECTION_CLASS)) return;

    var container = document.getElementById('main-collection-filters');
    if (!container || container.querySelector('[data-oz-free-au-custom-facets]')) return;

    container.insertAdjacentHTML('afterbegin', fallbackMarkup());
  }

  function bindCategorySearch() {
    document.querySelectorAll('[data-oz-category-search]').forEach(function (input) {
      if (input.dataset.ozBound === 'true') return;
      input.dataset.ozBound = 'true';

      input.addEventListener('input', function () {
        var panel = input.closest('[data-oz-free-au-custom-facets]');
        if (!panel) return;

        var needle = input.value.trim().toLowerCase();
        var visibleCount = 0;

        panel.querySelectorAll('[data-oz-category-item]').forEach(function (item) {
          var name = item.getAttribute('data-oz-category-name') || '';
          var visible = !needle || name.indexOf(needle) !== -1;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        var empty = panel.querySelector('[data-oz-category-empty]');
        if (empty) empty.style.display = visibleCount ? 'none' : 'block';
      });
    });
  }

  function enhance() {
    setPageClasses();
    updatePageTitle();
    injectLargeCatalogFacets();
    bindCategorySearch();
    preserveSearchView();
  }

  function queueEnhance() {
    if (queued) return;
    queued = true;

    window.requestAnimationFrame(function () {
      queued = false;
      enhance();
    });
  }

  function init() {
    enhance();

    var observer = new MutationObserver(queueEnhance);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('popstate', queueEnhance);
  document.addEventListener('shopify:section:load', queueEnhance);
})();
